import { routes } from '@Constants/routes';
import React from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { Route } from 'react-router';
import styled from 'styled-components';
import Menu from '../../Menu/Menu';
import Header from './Header';
import { map } from 'lodash';
import LoadingProvider from '@Providers/LoadingProvider';
import { RouteProvider } from '@Providers/Routes/RoutesProvider';
const DashboardLayout: React.FC = () => {
	const routeGroups = map(routes, 'routeGroups').flat(1);

	const { path } = useRouteMatch();
	return (
		<DashboardLayoutWrapper>
			<Menu />
			<RoutesLayoutWrapper>
				<LoadingProvider />
				<Header />
				<DashboardContentWrapper>
					<RouteProvider path={path}>
						<Switch>
							<Route
								path="/dashboard/manual-vc-requests"
								render={({ location }) => (
									<Redirect
										to={`/dashboard/invoices/manual-vc${location.search}`}
									/>
								)}
							/>
							<Route
								path="/dashboard/create-vc-request"
								render={({ location }) => (
									<Redirect
										to={`/dashboard/invoices/manual-vc?create=1&${location.search.slice(
											1
										)}`}
									/>
								)}
							/>
							<Route exact path={'/dashboard'}>
								<Redirect to={'/dashboard/students'} />
							</Route>
							{routeGroups &&
								Array.isArray(routeGroups) &&
								routeGroups.map((route, index) => {
									return (
										<Route
											key={`${index}-${route.route}-dl`}
											path={`/dashboard/${route.route}`}
										>
											{route.component}
										</Route>
									);
								})}
						</Switch>
					</RouteProvider>
				</DashboardContentWrapper>
				{/* </LoadingProvider> */}
			</RoutesLayoutWrapper>
		</DashboardLayoutWrapper>
	);
};

export default DashboardLayout;

const RoutesLayoutWrapper = styled.div`
	flex-grow: 1;
	min-height: 100%;
	/* overflow: auto; */
	/* overflow: auto; */
	width: 100%;
	display: grid;
	grid-template-rows: auto 1fr;
	position: relative;
	* {
		/* box-sizing: border-box; */
	}
`;
const DashboardLayoutWrapper = styled.div`
	display: flex;
	height: inherit;
	align-items: stretch;
	min-height: 100vh;
`;

const DashboardContentWrapper = styled.div`
	padding: 0 0.5rem;
	margin-bottom: 1.563rem;
	flex: 1;
`;
